<template>
    <div class="homeMainDiv">
        <div class="homeMainView">
            <van-cell class="typeNameDiv" :title="userInfoSession.kcName ? userInfoSession.kcName : '切换课程'" is-link @click="periodKcListShow = true;"></van-cell>
            <van-grid class="menuListDiv" :gutter="10" :border="false">
                <van-grid-item v-for="(item, index) in menuList" :key="index" icon="records-o" :text="item.name" @click="routeTo(item.value)"></van-grid-item>
            </van-grid>

            <van-row class="stuStatisticsMapDiv">
                <van-col span="8">
                    <div class="stuStatisticsMapInfo">
                        <p>{{stuStatisticsMap.totalAnswerNumber}}</p>
                        <p>今日答题</p>
                    </div>
                </van-col>
                <van-col span="8">
                    <div class="stuStatisticsMapInfo">
                        <p>{{stuStatisticsMap.totalAnswerYes}}</p>
                        <p>今日答对</p>
                    </div>
                </van-col>
                <van-col span="8">
                    <div class="stuStatisticsMapInfo">
                        <p>{{stuStatisticsMap.totalAccuracyRate}}%</p>
                        <p>正确率</p>
                    </div>
                </van-col>
            </van-row>
        </div>

        <van-popup v-model="periodKcListShow" position="left" :style="{ width: '100%', height: '100%' }" get-container=".homeMainView" :close-on-click-overlay="userInfoSession.typeId ? true : false">
            <van-nav-bar title="选择课程"></van-nav-bar>
            <van-grid class="kcInfoDiv" :gutter="10" :column-num="2">
                <van-grid-item v-for="(item, index) in periodKcList" :key="index" span="12" @click="periodKcActive(item)">
                    <template #default>
                        <div class="kcInfo">{{item.kcName}}</div>
                    </template>
                </van-grid-item>
            </van-grid>
        </van-popup>

        <van-tabbar v-model="tabbarActive" :fixed="false" class="tabbarSticky" @change="tabbarChange">
            <van-tabbar-item icon="records-o">题库</van-tabbar-item>
            <van-tabbar-item icon="contact-o">我的</van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
    export default {
        name: 'Home',
        data() {
            return {
                tabbarActive: 0,
                periodKcListShow: false,
                periodKcList: [],
                menuList: [
                    { name: '随机练习', value: 'RandomExercise' },
                    { name: '章节练习', value: 'ChapterExercise' },
                    { name: '我的错题', value: 'WrongTopic' },
                    { name: '我的收藏', value: 'Collection' },
                ],
                stuStatisticsMap: {
                    totalAnswerYes: 0,
                    totalAccuracyRate: 0,
                    totalAnswerNumber: 0,
                    totalAnswerNo: 0,
                },
            };
        },
        mounted() {
            var that = this;
            if (!that.userInfoSession.typeId) {
                that.routeTo('User');
                return false;
            }
            if (!that.userInfoSession.kcId) {
                that.periodKcListShow = true;
            } else {
                that.getStuStatisticsMap();
            }
            that.commonFn.getPeriodKcList(that);
        },
        watch: {},
        methods: {
            getStuStatisticsMap() {
                var that = this;

                var url = that.globalAPI.mainApi + 'stu/login/getStuStatisticsMap';

                var postData = {
                    data: {
                        typeId: that.userInfoSession.typeId,
                        typeName: that.userInfoSession.typeName,
                        kcId: that.userInfoSession.kcId,
                        kcName: that.userInfoSession.kcName,
                        operateId: that.userInfoSession.userId,
                        operateName: that.userInfoSession.userName,
                        merchantId: that.userInfoSession.merchantId,
                    },
                };

                postData = that.qs.parse(postData);

                that.axios
                    .post(url, postData)
                    .then(function (response) {
                        if (response.data.code == 1) {
                            that.stuStatisticsMap = response.data.data;
                        } else {
                            that.$toast.fail(response.data.msg);
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            periodKcActive(item) {
                var that = this;
                var userInfo = that.userInfoSession;
                userInfo.kcId = item.kcId;
                userInfo.kcName = item.kcName;
                localStorage.setItem('userInfoSession', JSON.stringify(userInfo));
                that.$store.commit('setUserInfoSession');
                that.periodKcListShow = false;
                that.$forceUpdate();
            },
            tabbarChange(index) {
                var that = this;
                if (index == 0) {
                    that.routeTo('');
                }
                if (index == 1) {
                    that.routeTo('User');
                }
            },
            routeTo(url, query) {
                this.$router.push({
                    path: '/' + url,
                    query: query,
                });
            },
        },
    };
</script>

<style scoped>
    .homeMainDiv {
        width: 100%;
        height: 100%;
        background-image: linear-gradient(to bottom, #3ab9fe, #fff);
    }

    .homeMainView {
        width: 100%;
        height: calc(100% - 50px);
        padding: 10px;
        box-sizing: border-box;
        overflow: auto;
    }

    .typeNameDiv {
        border-radius: 5px;
        box-sizing: border-box;
        overflow: hidden;
    }

    .menuListDiv {
        margin: 10px auto;
        border-radius: 5px;
        padding: 10px;
        box-sizing: border-box;
        overflow: hidden;
        background-color: #fff;
    }

    .kcInfoDiv {
        padding: 10px;
        box-sizing: border-box;
    }

    .kcInfoDiv >>> .van-grid-item__content {
        background-color: #3ab9fe;
        color: #fff;
    }

    .kcInfo {
        font-size: 14px;
    }

    .stuStatisticsMapDiv {
        margin: 10px auto;
        border-radius: 5px;
        padding: 10px;
        box-sizing: border-box;
        overflow: hidden;
        background-color: #fff;
    }

    .stuStatisticsMapInfo {
        width: 100%;
        text-align: center;
        line-height: 30px;
        height: 60px;
        overflow: hidden;
    }

    .stuStatisticsMapInfo p:first-child {
        font-weight: bold;
        font-size: 16px;
    }
</style>


// WEBPACK FOOTER //
// src/views/Home.vue